import { css } from 'lit';

export const styles = css`
	:host {
		display: flex;
		flex-direction: row;
		counter-reset: stepper;
		align-items: flex-start;
		text-align: center;

		--sds-stepper-circle-size: 32px;
	}

	:host([orientation='vertical']) {
		flex-direction: column;

		--sds-stepper-step-grid-template-rows: [line-1] auto [step-start] var(--sds-stepper-circle-size) [line-2 step-end] auto;
		--sds-stepper-step-grid-template-columns: var(--sds-stepper-circle-size) auto;

		--sds-stepper-step-step-grid-area: 2/1/-1/-1;
		--sds-stepper-step-step-grid-template-columns: [circle] var(--sds-stepper-circle-size) [content] auto;
		--sds-stepper-step-step-margin: 0 0 var(--sds-stepper-circle-size) 0;

		--sds-stepper-step-counter-grid-area: circle / 1;
		--sds-stepper-step-label-grid-area: auto;

		--sds-stepper-step-divider-before-visibility: hidden;
		--sds-stepper-step-divider-width: 1px;
		--sds-stepper-step-divider-height: 100%;
		--sds-stepper-step-divider-min-height: 1rem;
		--sds-stepper-step-divider-grid-row: line-2;
		--sds-stepper-step-divider-after-grid-column: 1;
		--sds-stepper-step-divider-before-display: none;

		--sds-stepper-step-step-gap: 0 var(--sds-spacing-3xs);
	}
`;
